<script lang="ts" setup>
import { computed } from '#imports';

const props = defineProps({
  percentage: {
    type: Number,
    default: 0,
    validator: (value: number) => value >= 0 && value <= 100,
  },
  bg: {
    // 背景色
    type: String,
    default: '#F0F0F0',
    validator: (v: string) => /^#([\da-f]{3}){1,2}$/i.test(v),
  },
  color: {
    // 进度条颜色
    type: String,
    default: '#00B42A',
    validator: (v: string) => /^#([\da-f]{3}){1,2}$/i.test(v),
  },
  size: {
    //尺寸大小
    type: Number,
    default: 14,
    validator: (v: number) => v > 0,
  },
});

const progressPath = computed(() => {
  const percent = Math.min(100, Math.max(0, props.percentage));

  // 处理 100% 的特殊情况
  if (percent === 100) {
    return `M7 7
      L7 0
      A7 7 0 1 1 6.9999 0
      Z`;
  }

  const angle = (percent / 100) * 360 - 90;
  const x = 7 + 7 * Math.cos((angle * Math.PI) / 180);
  const y = 7 + 7 * Math.sin((angle * Math.PI) / 180);
  const largeArc = percent > 50 ? 1 : 0;

  return `
    M7 7
    L7 0
    A7 7 0 ${largeArc} 1 ${x} ${y}
    Z
  `;
});
</script>
<template>
  <div class="relative" :style="{ width: `${size}px`, height: `${size}px` }">
    <svg :width="size" :height="size" viewBox="0 0 14 14">
      <!-- 背景圆 -->
      <circle cx="7" cy="7" r="7" :fill="bg" />

      <!-- 动态扇形 -->
      <path :d="progressPath" :fill="color" />
    </svg>
  </div>
</template>
